module.exports = __webpack_public_path__ + "img/icon_gongneng7.9a9420c6.svg";